import { render, staticRenderFns } from "./MoleculeEditionAcademyUsers.vue?vue&type=template&id=60cee294&"
import script from "./MoleculeEditionAcademyUsers.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports